import React from 'react';

const TransactionIconAdmin = ({ stroke }) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.48543 13.633C5.0321 13.0463 5.86544 13.093 6.34544 13.733L7.01877 14.633C7.55877 15.3463 8.43211 15.3463 8.97211 14.633L9.64544 13.733C10.1254 13.093 10.9588 13.0463 11.5054 13.633C12.6921 14.8997 13.6588 14.4797 13.6588 12.7063V5.19301C13.6588 2.50634 13.0321 1.83301 10.5121 1.83301H5.47211C2.95211 1.83301 2.32544 2.50634 2.32544 5.19301V12.6997C2.33211 14.4797 3.30543 14.893 4.48543 13.633Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.16675 7.16699H9.83341" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default TransactionIconAdmin;
